import { ActionTypes } from "../contants/actions-types";

export const setProduct = (produits, refrech) => {
    return {
        type: ActionTypes.SET_PRODUCTS,
        payload: produits,
        // refre: refrech,
    }
}

export const selectProduct = (produit) => {
    return {
        type: ActionTypes.SELECT_PRODUCT,
        payload: produit,
        // payload2: 1
       
    }
};

export const addtoCard = (produit) => {
    return {
        type: ActionTypes.ADD_TO_CARD,
        payload: produit,
    }
}
export const deleteInCard = (id) => {
    return {
        type: ActionTypes.DELETE_IN_CARD,
        payload: id,
    }
}

export const deleteAllCard = () => {
    return {
        type: ActionTypes.DELETE_ALL_CARD,
        // payload: produits,
    }
}

// export const deleteInCard = (id) => {
//     return {
//         type: ActionTypes.DELETE_IN_CARD,
//         payload: id,
//     }
// } 

export const setCategProducts = (categProducts) => {
    return {
        type: ActionTypes.SET_CATEG_PRODUCTS,
        payload: categProducts,
    }
}

export const removeselectedproduit = () => {
    return {
        type: ActionTypes.REMOVE_SELECTED_PRODUCT,
    }
}

export const addProduct = (produit) => {
    return {
        type: ActionTypes.ADD_PRODUCT,
        payload: produit,
    }
}